import { Box, Button, TextField, Typography} from '@mui/material'
import React from 'react'
import { AddBox1 } from '../../../../../../../../core/global/Icons'
import { Remove } from '@mui/icons-material'

export const BestFor = ({ inputs, handleChange, classes, bestforHandler, handleInclusion, }) => {
    return (

        <Box width="100%" display="flex" alignItems="center" flexDirection="column" gap={3}>
            <Box width="100%" onClick={() => handleInclusion('bft')}>
            <Typography noWrap width="100%" display="flex" fontWeight={600}>Title <Box ml={1} fontSize={20} color="red">*</Box></Typography>
                <TextField multiline className={classes.txtfld}  onChange={(e) => handleChange(e)} name="bestfor_title" value={inputs.names.bestfor_title.value} error={inputs.names.bestfor_title.stat} helperText={inputs.names.bestfor_title.msg} />
            </Box>
            <Box>
                <Box display="flex" alignItems="center" justifyContent="space-between" my={1}>
                    <Box width="100%" mt={.5} display="flex" fontWeight={600}>Item<Box ml={1} fontSize={20} color="red">*</Box></Box>
                    <Box width="100%" display="flex" justifyContent="end" component={Button} minWidth="" onClick={() => bestforHandler('add')}><AddBox1 stroke="#2D503E" width={20} /></Box>
                </Box>
                <Box width="100%" display="flex" flexDirection="column" gap={1}>
                    {
                        inputs.names.bestfor_items.map((i, k) => (
                            <Box width={260} display="flex" alignItems="center" gap={1} key={k} onClick={() => handleInclusion('bfi')}>
                                <TextField className={classes.txtfld} onChange={(e) => handleChange(e, k)}
                                    name="bestfor_items"
                                    value={i.value}
                                    variant="outlined" error={i.stat} helperText={i.msg} size="small" />
                                {
                                    inputs.names.bestfor_items.length > 1 &&
                                    <Box display="flex" component={Button} minWidth="" onClick={() => bestforHandler('remove', k)}>
                                        <Remove sx={{ color: '#FA3E3E' }} />
                                    </Box>
                                }
                            </Box>
                        ))
                    }
                </Box>
            </Box>
        </Box>

    )
}


export const Features = ({ featuresHandler, t_form, handleChange, classes, handleInclusion }) => {
    const inputs = t_form.data.styles
    return (

        <Box width="100%" display="flex" alignItems="center" flexDirection="column" gap={3}>
            <Box width="100%" onClick={() => handleInclusion('ft')}>
                <TextField className={classes.txtfld} onChange={(e) => handleChange(e)} name="feature_title" value={inputs.names.feature_title.value} error={inputs.names.feature_title.stat} helperText={inputs.names.feature_title.msg} />
            </Box>
            <Box>
                <Box display="flex" alignItems="center" justifyContent="space-between" my={1}>
                    <Box width="100%" mt={.5} display="flex" fontWeight={600}>Item<Box ml={1} fontSize={20} color="red">*</Box></Box>
                    <Box width="100%" display="flex" justifyContent="end" component={Button} minWidth="" onClick={() => featuresHandler('add')}><AddBox1 stroke="#2D503E" width={20} /></Box>
                </Box>
                <Box width="100%" display="flex" flexDirection="column" gap={1}>
                    {
                        inputs.names.feature_items.map((i, k) => (
                            <Box width={260} display="flex" alignItems="center" gap={1} key={k} onClick={() => handleInclusion('fi')}>
                                <TextField className={classes.txtfld} onChange={(e) => handleChange(e, k)} name="feature_items" value={i.value} variant="outlined" error={i.stat} helperText={i.msg} size="small" />
                                {
                                    inputs.names.feature_items.length > 1 &&
                                    <Box display="flex" component={Button} minWidth="" onClick={() => featuresHandler('remove', k)}>
                                        <Remove sx={{ color: '#FA3E3E' }} />
                                    </Box>
                                }
                            </Box>
                        ))
                    }
                </Box>
            </Box>
        </Box>

    )
}
